import { getFileName } from "./filename";
import { saveAs } from "file-saver";

export const handleSaveProject = async (klausur, companies, schueler) => {
  const fileName = `${getFileName(klausur, companies, schueler)}.project`;
  const obj = { klausur, schueler };
  const stringifiedObj = JSON.stringify(obj);
  var blob = new Blob([stringifiedObj], { type: "text/plain;charset=utf-8" });
  saveAs(blob, fileName);
};
